import script from "./NavigationGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationGuide.vue?vue&type=script&setup=true&lang=js"

import "./NavigationGuide.vue?vue&type=style&index=0&id=8582e45e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8582e45e"]])

export default __exports__